var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ul',{attrs:{"id":"xmltree"}},_vm._l((_vm.treeData.treeItems),function(child){return _c('xml-tree-item',{key:child.itemId,staticClass:"item",attrs:{"readonly":_vm.readonly,"item":child}})}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }